module.exports = __webpack_public_path__ + "static/media/app_votorantim.6b1b966a.jpg";